module.exports = {
  '@primary-grey': '#AEAEAE',
  '@primary-green': '#74d98a',
  '@secondary-red': '#ee4b2b',
  '@text-gray': '#909090',

  // -=-=-=- header colors -=-=-=-=-
  '@header-background': '#FAFBFC',
};
